export const iconCategories = [
  "brand",
  "playback",
  "general",
  "commerce",
  "content",
  "sharing",
  "gifting",
  "flags",
] as const;

export type IconCategory = (typeof iconCategories)[number];

export const iconCategoryLabels: Record<IconCategory, string> = {
  brand: "Brand",
  playback: "Playback",
  general: "General",
  commerce: "Commerce",
  content: "Content",
  sharing: "Sharing",
  gifting: "Gifting",
  flags: "Flags",
};
